import {
    FETCH_USER_TYPE,
    FETCH_USER_DATA,
    FETCH_LOGGED_IN,
    FETCH_SIGNED_UP,
    FETCH_CLIENT_DATA,
    FETCH_CLIENT_ADDRESS_LIST,
    FETCH_POSTCODE_ADDRESS_LIST,
    FETCH_PAYMENT_METHODS,
    CLEAR_PAYMENT_METHODS,
    ERROR_MESSAGE,
    ADD_ADDRESS,
    REMOVE_ADDRESS,
    FETCH_BUZZ_WORKERS,
    FETCH_CUSTOMERS,
} from '../actions/ClientData';

export const findAddress = payload => item => {
    if (!payload || !payload.postcode) {
        return false;
    }
    if (payload.url) {
        return item.url === payload.url;
    }
    return (
        item.address1 === payload.address1 &&
        item.address2 === payload.address2 &&
        item.city === payload.city &&
        item.postcode === payload.postcode
    );
};

export default function(state = {}, action) {
    const new_state = JSON.parse(JSON.stringify(state));

    // eslint-disable-next-line default-case
    switch (action.type) {
        case FETCH_USER_TYPE:
            new_state.userType = action.payload;
            return new_state;
        case FETCH_USER_DATA:
            new_state.userData = action.payload;
            return new_state;
        case FETCH_LOGGED_IN:
            new_state.loggedIn = action.payload;
            return new_state;
        case FETCH_SIGNED_UP:
            new_state.signedUp = action.payload;
            return new_state;
        case FETCH_CLIENT_DATA:
            new_state.basicInfo = action.payload;
            return new_state;
        case FETCH_CLIENT_ADDRESS_LIST:
            new_state.clientAddressList = action.payload;
            return new_state;
        case ADD_ADDRESS:
            new_state.clientAddressList.push(action.payload);
            return new_state;
        case REMOVE_ADDRESS:
            const index = new_state.clientAddressList.findIndex(
                findAddress(action.payload),
            );
            if (index !== -1) {
                new_state.clientAddressList.splice(index, 1);
            }
            return new_state;
        case FETCH_POSTCODE_ADDRESS_LIST:
            new_state.postcodeAddressList = action.payload.content;
            return new_state;
        case ERROR_MESSAGE:
            new_state.error[action.payload.field] = action.payload.message;
            return new_state;
        case FETCH_PAYMENT_METHODS:
            new_state.paymentMethods = action.payload;
            return new_state;
        case CLEAR_PAYMENT_METHODS:
            new_state.paymentMethods = action.payload;
            return new_state;
        case FETCH_BUZZ_WORKERS:
            new_state.buzzworkers = action.payload;
            return new_state;
        case FETCH_CUSTOMERS:
            new_state.customers = action.payload;
            return new_state;
    }

    return state;
}
